<div class="mb-xl-2"></div>
<div class="container-fluid" id="logTable">
  <p-table #tt [value]="logs" [paginator]="true" [rows]="30"
      [globalFilterFields]="['source','date','brand','firstName','lastName','code','action','user','key','before','after']"
      [sortField]="'date'" [sortOrder]=-1 [sortMode]="'single'" 
  >
    <ng-template pTemplate="caption">
      <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
      <input type="search" pInputText size="50" placeholder="Global Filter" (input)="globalFilter($event, 'contains')" style="width:auto" />
      <label class="load-logs" for="startDate">Logs Between:</label>
      <input id="startDate" type="date" autocomplete="off" #startDate min="{{minDateStr}}" max="{{maxDateStr}}" value="{{defaultStartDateStr}}"/>
      <label class="load-logs" for="endDate">and:</label>
      <input id="endDate" type="date" autocomplete="off" #endDate min="{{minDateStr}}" max="{{maxDateStr}}" value="{{maxDateStr}}"/>
      <span class="load-logs" *ngIf="!logsLoading else logsLoadingBlock">
        <button type="button" class="btn btn-primary" (click)="loadChangeLogs(startDate.value, endDate.value)" >Load Change Log</button>
      </span>
      <span class="load-logs">
        <button type="button" class="btn btn-primary" (click)="exportLogs()" [disabled]="logs.length == 0">Export Logs</button>
      </span>
      <ng-template #logsLoadingBlock>
        <div class="load-logs spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </ng-template>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <ng-container *ngFor="let col of cols">
          <th *ngIf="((col.field == 'job') || (col.field == 'recorderPerBrand')) else sortableBlock">
            {{col.header}}
          </th>
          <ng-template #sortableBlock>
            <th [pSortableColumn]="col.field">
              {{col.header}}
              <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order" 
                ariaLabelAsc="Activate to sort in ascending order">
              </p-sortIcon>
            </th>  
          </ng-template>
        </ng-container>
      </tr>
      <tr>
        <th *ngFor="let col of cols">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'source'">
              <select name="source" style="width: 100%;" (change)="applyFilter($event, col.field, 'startsWith')">
                <option value="">All</option>
                <option value="order">Order</option>
                <option value="upload">Upload</option>
              </select>
            </ng-container>
            <ng-container *ngSwitchCase="'date'">
              <div>
                <p-calendar [appendTo]="'body'" [selectionMode]="'range'" [readonlyInput]=true [dateFormat]="'dd/mm/yy'"
                    [(ngModel)]="dateFilters" (onSelect)="tt.filter(dateFilters, col.field, 'date-range')"
                    (onClearClick)="tt.filter(dateFilters, col.field, 'date-range')" [yearRange]=filterYearRange
                    [monthNavigator]=true [yearNavigator]=true [showButtonBar]=true [keepInvalid]=false
                    [minDate]=filterMinDate [maxDate]=filterMaxDate [numberOfMonths]="1"
                    [showOtherMonths]=true [selectOtherMonths]=true [showIcon]=true 
                    [style]="{width: '100%'}" [inputStyle]="{width: '100%'}">
                </p-calendar>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'brand'">
              <p-multiSelect [options]="brands" [(ngModel)]="selectedBrand"
                  filterPlaceHolder="brand" scrollHeight="600px" [maxSelectedLabels]=0
                  selectedItemsLabel="{0} selected" [style]="{'display':'flex'}" 
                  (onChange)="tt.filter($event.value, col.field, 'in')" >
                <ng-template let-Pbrand let-i="index" pTemplate="item">
                  <div class="brandBar" [ngStyle]="{'background-color': brandConfigs[Pbrand.value].background, 'color':brandConfigs[Pbrand.value].color}">
                    &nbsp;{{Pbrand.value}}
                  </div>
                </ng-template>
              </p-multiSelect>
            </ng-container>
            <ng-container *ngSwitchCase="'code'">
              <input pInputText type="search" (input)="applyFilter($event, col.field, 'equals')" style="width: 100%;" />
            </ng-container>
            <ng-container *ngSwitchCase="'action'">
              <select name="source" style="width: 100%;" (change)="applyFilter($event, col.field, 'startsWith')">
                <option value="">All</option>
                <option value="add">add</option>
                <option value="remove">remove</option>
                <option value="update">update</option>
              </select>
            </ng-container>
            <ng-container *ngSwitchCase="'user'">
              <input pInputText type="search" (input)="applyFilter($event, col.field, 'startsWith')" style="width: 100%;" />
            </ng-container>
            <ng-container *ngSwitchCase="'key'">
              <input pInputText type="search" (input)="applyFilter($event, col.field, 'contains')" style="width: 100%;" />
            </ng-container>
            <ng-container *ngSwitchCase="'fields'">
              <input pInputText type="search" (input)="applyFilter($event, col.field, 'contains')" style="width: 100%;" />
            </ng-container>
            <ng-container *ngSwitchCase="'before'">
              <input pInputText type="search" (input)="applyFilter($event, col.field, 'contains')" style="width: 100%;" />
            </ng-container>
            <ng-container *ngSwitchCase="'after'">
              <input pInputText type="search" (input)="applyFilter($event, col.field, 'contains')" style="width: 100%;" />
            </ng-container>
            <ng-container *ngSwitchCase="'recorderPerBrand'">
              <p-multiSelect *ngIf="col.header == 'Brands'" [options]="brands" [(ngModel)]="selectedBrands"
                  filterPlaceHolder="brand" scrollHeight="600px" [maxSelectedLabels]=0
                  selectedItemsLabel="{0} selected" [style]="{'display':'flex'}" 
                  (onChange)="tt.filter($event.value, col.field, 'brand-count')" >
                <ng-template let-Pbrand let-i="index" pTemplate="item">
                  <div class="brandBar" [ngStyle]="{'background-color': brandConfigs[Pbrand.value].background, 'color':brandConfigs[Pbrand.value].color}">
                    &nbsp;{{Pbrand.value}}
                  </div>
                </ng-template>
              </p-multiSelect>
            </ng-container>
            <ng-container *ngSwitchDefault></ng-container>
          </ng-container>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-log>
      <tr>
        <td>{{log.source}}</td>
        <td>{{log.date | date:'dd/MM/y HH:mm'}}</td>
        <td>{{log.brand}}</td>
        <td>{{log.firstName}}</td>
        <td>{{log.lastName}}</td>
        <td>{{log.code}}</td>
        <td>{{log.action}}</td>
        <td>{{log.user}}</td>
        <td>{{log.key}}</td>
        <td>{{log.fields}}</td>
        <td>{{log.before}}</td>
        <td>{{log.after}}</td>
        <td>{{log.nbRecorders}}</td>
        <td>
          <div *ngIf="log.recorderPerBrand">
            <div *ngFor="let key of objectKeys(log.recorderPerBrand) ; let i = index "><p>{{key}}</p>
              <hr>
            </div>
          </div>
        </td><td>
          <div *ngIf="log.recorderPerBrand">
            <div *ngFor="let key of objectKeys(log.recorderPerBrand) ; let i = index "><p>{{log.recorderPerBrand[key]}}</p>
              <hr>
            </div>

          </div>
        </td>
        <td>{{log.fileName}}</td>
      </tr>
    </ng-template>

    <ng-template pTemplate="summary">
      There are {{logs?.length}} change logs
    </ng-template>

  </p-table>
</div>
<p-toast></p-toast>